/**
 * Remembers, in this browser, that the learner left for Stripe Checkout. The
 * return URL's ?checkout=success can be lost on the way back (a sign-in or
 * redirect in between), so the case list also checks this to say thank you.
 */
const KEY = "morningReportCheckoutStartedAt";
const MAX_AGE_MS = 2 * 60 * 60 * 1000;

export function markCheckoutStarted() {
  try {
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* storage blocked: the URL parameter still works */
  }
}

/** True when a checkout started here in the last two hours. */
export function checkoutStartedRecently() {
  try {
    const at = Number(sessionStorage.getItem(KEY));
    return Number.isFinite(at) && at > 0 && Date.now() - at < MAX_AGE_MS;
  } catch {
    return false;
  }
}

export function clearCheckoutStarted() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* nothing to clear */
  }
}
